const liveStreaming = {
  // 用户实名信息
  getRealNameInfo: `/liveApi/api/v3/Withdraw/realNameInfo`,
  // 发送短信验证
  getSendCode: `/liveApi/api/v3/Withdraw/sendCode`,
  // 主播中心数据
  getWithdrawRule: `/liveApi/api/v3/Withdraw/rule`,
  // 提现规则
  getAnchorCenter: `/liveApi/api/v3/Withdraw/anchorCenter`,
  // 检测是否绑定支付宝或银行卡
  getCheckBindAcct: `/liveApi/api/v3/Withdraw/checkBindAcct`,
  // 绑定支付宝账号
  getBindAliPayAcct: `/liveApi/api/v3/Withdraw/bindAliPayAcct`,
  // 解绑支付宝账号
  getUnbindAliPayAcct: `/liveApi/api/v3/Withdraw/unbindAliPayAcct`,
  // 绑定银行卡账号
  getBindBankCard: `/liveApi/api/v3/Withdraw/bindBankCard`,
  // 解绑银行卡账号
  getUnbindBankCard: `/liveApi/api/v3/Withdraw/unbindBankCard`,
  // 更改银行卡账号
  getChangeBankCard: `/liveApi/api/v3/Withdraw/changeBankCard`,
  // 提现页面数据
  getWithdrawPage: `/liveApi/api/v3/Withdraw/withdrawPage`,
  // 提交提现请求
  getDoWithdraw: `/liveApi/api/v3/Withdraw/doWithdraw`,
  // 收入明细
  getPcIncomeRecord: `/liveApi/api/v3/Withdraw/pcIncomeRecord`,
  // 支出明细
  getPcExpendRecord: `/liveApi/api/v3/Withdraw/pcExpendRecord`,
  // 用户签约
  getUserSign: `/liveApi/api/v3/Withdraw/userSign`,
  // 计算税费
  calcTax: `/liveApi/api/v3/Withdraw/calcTax`,
  // 预估税金说明
  estimatedTaxExplain: `/liveApi/api/v3/Withdraw/estimatedTaxExplain`,
  // java
  // 主播数据统计图
  anchorGraph: `/authApi/show/v1/pc/anchorGraph`,
  // 直播时间段数据
  livePeriodReport: `/authApi/show/v1/pc/livePeriodReport`,
  // 直播场次
  sessionReport: `/authApi/show/v1/pc/sessionReport`,
  // 直播间在线用户
  queryLiveRoomOnlineUsers: `/authApi/show/v1/queryLiveRoomOnlineUsers`,
  // 直播间在线用户数量
  queryLiveRoomUserNum: `/authApi/show/v1/queryLiveRoomUserNum`,
  // 直播间热力值规则
  queryLiveRoomPowerRuleDesc: `/authApi/show/v1/queryLiveRoomPowerRuleDesc`,
  // 直播间热力榜排行榜
  queryLiveRoomRankList: `/authApi/show/v1/queryLiveRoomRankList`,
  // 直播间TOP热力值用户
  queryLiveRoomTopRankUsers: `/authApi/show/v1/queryLiveRoomTopRankUsers`,
  // 分享直播间操作记录接口
  liveRoomShareRecord: `/authApi/show/v1/liveRoomShareRecord`,
  // php
  // 直播导游戏统计
  guideGameST: `/liveApi/api/v3/Anchor/guideGameST`,
  // 直播导游戏统计图
  guideGameChart: `/liveApi/api/v3/Anchor/guideGameChart`
};

export default liveStreaming;
